import { render, staticRenderFns } from "./FilterUserBlock.vue?vue&type=template&id=631a3e87"
import script from "./FilterUserBlock.vue?vue&type=script&lang=js"
export * from "./FilterUserBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports